import { render, staticRenderFns } from "./ModalManageCategories.vue?vue&type=template&id=12df2990"
import script from "./ModalManageCategories.vue?vue&type=script&lang=js"
export * from "./ModalManageCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports